/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAddEditPage = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v16h4v2H4zm11 3.414V7h1.586zm2.293 6.879a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414L16.414 22H12v-4.414zM14 18.414V20h1.586l4-4L18 14.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAddEditPage as AddEditPage };
